/**
 * Fermentation type of champagne
 */
export type ChampagneFermentationType = 'BOTTLE_FERMENTED' | 'TANK_FERMENTED';

export const ChampagneFermentationType = {
  BottleFermented: 'BOTTLE_FERMENTED' as ChampagneFermentationType,
  TankFermented: 'TANK_FERMENTED' as ChampagneFermentationType,
};
